import Drawer from '@mui/material/Drawer';

import { css, styled } from '../../Utils/style';

export const StyledDrawer = styled(Drawer, { name: 'SwipeableDrawer', slot: 'root' })`
  ${({ theme, $ctaAlignSelf }) => css`
    .MuiPaper-root {
      padding: ${theme.spacing(5)} 0;

      .ctaButton {
        align-self: ${$ctaAlignSelf};
      }

      .drawerContent {
        display: flex;
        flex-direction: column;
        padding: 0 ${theme.spacing(4)};

        .drawerCloseIcon {
          padding: 0;
          align-self: end;
        }

        p {
          margin-bottom: ${theme.spacing(3)};
        }

        .drawerTitle {
          align-self: flex-start;
          display: flex;
          margin: ${theme.spacing(3)} 0;

          img {
            margin-right: ${theme.spacing(1)};
          }
        }

        ${theme.breakpoints.up('sm')} {
          width: 50%;
          margin: 0 auto;
          padding: 0;
        }
      }
    }
  `}
`;

export const TriggerButtonBox = styled('div')`
  ${({ theme, $hasTopBorder }) => css`
    width: 100%;
    height: 7.2rem;
    padding: ${theme.spacing(3)} ${theme.spacing(4)};
    border-top: ${$hasTopBorder ? `2px solid ${theme.palette.grey.main}` : 'none'};

    .MuiButtonBase-root {
      &.drawerButtonOpenDrawer {
        height: 2.4rem;
      }
    }
  `}
`;
